import { useEffect } from 'react';

/** Injects JSON-LD <script> tags into <head> for the current page, removed on unmount. */
export function useSchema(schema: object | object[]) {
  useEffect(() => {
    const items = Array.isArray(schema) ? schema : [schema];
    const createdIds: string[] = [];

    // Clean up any stale template schema left over from root index.html during SPA prerendering
    if (Array.isArray(schema) || (schema && '@type' in schema)) {
      document.getElementById('page-schema')?.remove();
    }

    items.forEach((item, index) => {
      const type = (item as any)?.['@type'];
      const id = items.length === 1 && !type ? 'page-schema' : (type ? `page-schema-${type}` : `page-schema-${index}`);
      createdIds.push(id);

      let script = document.getElementById(id) as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(item);
    });

    return () => {
      createdIds.forEach((id) => {
        document.getElementById(id)?.remove();
      });
    };
  }, [schema]);
}
